<template>
  <IQOS :systemDependency="'reserve'">
    <template v-slot:header>
        QRWaiter Marketplace Policy | <span class="reserve-badge">
            RESERVE
        </span>
    </template>
    <RoundCheckbox v-model="terms_argeed">
      <div class="checkbox-text">
        {{ $t("reserve_policy.checkbox") }}
      </div>
    </RoundCheckbox>

    <p class="comment c-gray">
      {{ $t("reserve_policy.text") }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

export default {
  data() {
    return {
      terms_argeed: true,
    };
  },
  components: {
    IQOS,
    RoundCheckbox,
  },
};
</script>

<style scoped>
.checkbox-text {
  /* font-size: 1.7vh; */
  width: 100%;
}

.reserve-badge {
    color: #AECCC6 !important;
}
</style>